<template>
  <div class="ui-pivot-table-sidebar-caption" @click="handleClick">
    <span>{{ caption }}</span>
    <component :is="component" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/vue/20/solid'

type Props = {
  caption: string
}

defineProps<Props>()

const modelValue = defineModel<boolean>({ required: true })

const component = computed(() =>
  modelValue.value ? ChevronUpIcon : ChevronDownIcon,
)

const handleClick = () => {
  modelValue.value = !modelValue.value
}
</script>

<style>
.ui-pivot-table-sidebar-caption {
  @apply h-8;
  @apply sticky top-0 z-10;
  @apply flex items-center justify-between;
  @apply px-2;
  @apply text-gray-950 dark:text-gray-50;
  @apply bg-gray-100 dark:bg-gray-850;
  @apply font-medium text-sm sm:text-xs uppercase;
  @apply cursor-pointer sm:cursor-default;

  svg {
    @apply w-5 h-5;
    @apply sm:hidden;
  }
}
</style>
